import {
  useDataPresentationParam,
  useDatasourceId,
  useQueryId,
  useSeriesId,
} from '@/hooks';
import { useNavigate } from 'react-router-dom';

export const useNavigateToDataPresentation = (
  nextDataPresentation?: string,
) => {
  const navigate = useNavigate();
  const dataPresentation = useDataPresentationParam();
  const datasourceId = useDatasourceId();
  const queryId = useQueryId();
  const seriesId = useSeriesId();

  const queryPath = seriesId
    ? `saved-queries/${seriesId}`
    : `queries/${queryId}`;

  const dataPresentationPath = nextDataPresentation
    ? `/${nextDataPresentation}`
    : '';

  const url = `/datasources/${datasourceId}/${queryPath}${dataPresentationPath}`;

  return dataPresentation === nextDataPresentation
    ? undefined
    : () => navigate(url);
};
